export default __webpack_public_path__ + "static/media/empty-cactus.526d14b6.svg";